import { Action, createReducer, on } from '@ngrx/store';
import { Course, StepBlock, StepsCategoryModel } from '@tekman/onmat/models';
import * as coursesActions from './courses.actions';

export const COURSES_FEATURE_KEY = 'courses';

export interface State {
  courses: Course[];
  blocks: Array<StepBlock[]>;
  stepsCategory: StepsCategoryModel | null;
  loaded: { [key: string]: boolean };
}

export interface StepsPartialState {
  readonly [COURSES_FEATURE_KEY]: State;
}

export const initialState: State = {
  courses: [],
  blocks: [],
  stepsCategory: null,
  loaded: {},
};

const stepsReducer = createReducer(
  initialState,
  on(coursesActions.loadCoursesSuccess, (state, { courses }) => ({
    ...state,
    courses,
    loaded: { ...state.loaded, courses: true },
  })),
  on(coursesActions.loadStepBlocksByCourseSuccess, (state, { courseId, blocks }) => ({
    ...state,
    blocks: { ...state.blocks, [courseId]: blocks },
    loaded: { ...state.loaded, blocks: true },
  })),
  on(coursesActions.loadStepsSuccess, (state, { stepsCategory }) => ({
    ...state,
    stepsCategory,
    loaded: { ...state.loaded, blocks: true },
  })),
  on(
    coursesActions.loadCoursesFailure,
    coursesActions.loadStepBlocksByCourseFailure,
    coursesActions.loadStepsFailure,
    (state, { error }) => ({
      ...state,
      message: error.message,
      loaded: { ...state.loaded, [error.type]: false },
    })
  )
);

export function reducer(state: State | undefined, action: Action) {
  return stepsReducer(state, action);
}
